import { Component, OnInit } from '@angular/core';
import { userProfile } from 'src/app/interfaces/iresponse';
import { UserService } from 'src/app/services/apiCalls/userService/user.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css'],
})
export class UserProfileComponent implements OnInit {
  breadCrumb: any;
  loadingProfile: boolean = false;
  profileDetails!: userProfile;
  constructor(private userService: UserService) { }

  ngOnInit(): void {
    this.getProfile()
    this.breadCrumb  = {
      name: 'Profile',
      parent: 'Home',
      subLink: null
    };
  }

  getProfile(){
    this.loadingProfile = true;
    return this.userService.getUserProfile().subscribe({
      next:(response)=>{
        this.profileDetails = response;
      },
      error: (err)=>{

      }
    }).add(()=> this.loadingProfile = false)
  }

}
